import dayjs, { type Dayjs } from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)
dayjs.extend(customParseFormat)

const DOCUMENT_DATE_WIRE_FORMAT = "YYYY-MM-DD"

// A document date is a bare calendar day, not an instant. `getFormatDate`
// re-zones its input, which turns a day's midnight into the evening before
// for a profile west of the browser's zone.
const readDay = (value: string | null | undefined): Dayjs | null => {
  if (!value) return null
  const day = dayjs.utc(value, DOCUMENT_DATE_WIRE_FORMAT, true)
  return day.isValid() ? day : null
}

export const readDocumentDay = (
  value: string | null | undefined
): number | null => readDay(value)?.valueOf() ?? null

export const formatDocumentDate = (
  value: string | null | undefined
): string | null => readDay(value)?.format("MMMM D, YYYY") ?? null
